import { render, staticRenderFns } from "./IconTranscriptionFailed.vue?vue&type=template&id=4c4a6519&"
import script from "./IconTranscriptionFailed.vue?vue&type=script&lang=js&"
export * from "./IconTranscriptionFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4a6519')) {
      api.createRecord('4c4a6519', component.options)
    } else {
      api.reload('4c4a6519', component.options)
    }
    module.hot.accept("./IconTranscriptionFailed.vue?vue&type=template&id=4c4a6519&", function () {
      api.rerender('4c4a6519', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTranscriptionFailed.vue"
export default component.exports